import { FONT_TITLE, FONT_COPY } from '../../constants/AppConstants';

export default class HowToPlayPanel extends Phaser.Group {
  constructor(game, { title = 'title', copy = '', image = '' }) {
    super(game);

    this.image = this.game.make.image(0, 0, image);
    this.add(this.image);

    this.title = this.game.make.text(0, 0, title, {
      font: '42px ' + this.game.titleFontStyle,
      fill: '#0090C1',
      wordWrap: true,
      wordWrapWidth: 290,
      align: this.game.fontAlign,
    });
    this.title.lineSpacing = -10;
    this.title.x = 50;
    this.title.y = 50;
    this.add(this.title);

    this.copy = this.game.make.text(0, 0, copy, {
      font: '22px ' + FONT_COPY,
      fill: '#005888',
      wordWrap: true,
      wordWrapWidth: 270,
      align: this.game.fontAlign,
    });
    this.copy.lineSpacing = -3;
    this.copy.x = 50;
    this.copy.y = this.title.y + this.title.height + 20;
    this.add(this.copy);
  }

  get width() {
    return this.image.width;
  }

  get height() {
    return this.image.height;
  }
}



// WEBPACK FOOTER //
// ./js/app/ui/howtoplay/HowToPlayPanel.js